module.exports = "/_next/static/images/vip40-deal-a002fed8fbd0128ff9b3762fc34fd2ab.png";